import { ClickListener } from "../../../../../lib/web/components/click-listener";
import { Component } from "../../../../../lib/web/components/component";
import { ComponentBase } from "../../../../../lib/web/components/component-base";
import { DiscoveryAssistantStep } from "../../pages/discovery-assistant/discovery-assistant.component";
import { MediaPlayerService } from "../../../services/media-player.service";
import { SessionService } from "../../../services/session.service";
import { ChildrenRef } from "../../../../../lib/web/components/children-ref";
import { DataEventService } from "../../../services/data-event.service";

@Component({
    selector: '.o-discovery-assistant-intro'
})
export class DiscoveryAssistantIntroComponent extends ComponentBase<HTMLElement> implements DiscoveryAssistantStep {

    private _assistant: any = null;

    @ChildrenRef(HTMLButtonElement, '.o-discovery-assistant-intro__locale')
    private _buttonLocales: HTMLButtonElement[] = [];
   
    public constructor(node: HTMLElement, private _mediaPlayerService: MediaPlayerService, private _sessionService: SessionService, private _dataEventService: DataEventService) {
        super(node);

        this._mediaPlayerService.on('player-closed', async (e? : { ended?: boolean, skipped?: boolean }) => {
            if (e?.ended) {
                this.showVideoEnded();
            }
            if (e?.skipped) {
                this.onNext();
            }
        }, this);
    }

    public onInit(): void {
        super.onInit(); 
        this.setLocale(this._sessionService.getLanguage() || CONFIG.DEFAULT_LOCALE);       
    }

    @ClickListener('.o-discovery-assistant-intro__play')
    public onStart(): void {        
        this.openIntroVideo();
    }

    @ClickListener('.o-discovery-assistant-intro__goToQuestions')
    public onGoToQuestions(): void {
        this.onNext();
    }

    @ClickListener('.o-discovery-assistant-intro__watchAgain')
    public onWatchAgain(): void {
        this.openIntroVideo();
    }

    @ClickListener('.o-discovery-assistant-intro__videoEndedClose')
    public onCloseVideoEnded(): void {
        this.addClass('u-hidden', '.o-discovery-assistant-intro__videoEnded');
        this.removeClass('u-hidden', '.o-discovery-assistant-intro__container');
    }

    @ClickListener('.o-discovery-assistant-intro__next')
    public onNext(): void {
        this.onCloseVideoEnded();
        window.dispatchEvent(new CustomEvent('discovery-assistant-next-step'));
    }

    @ClickListener('.o-discovery-assistant-intro__locale')
    public onLocaleChange(e: MouseEvent): void {
        this.setLocale((e.currentTarget as HTMLButtonElement).dataset.locale);
    }

    public enter(assistant: any, interestClusters: any[], mode: string): void {
        this._assistant = assistant;
        this._dataEventService.onboarding();
    }

    public exit(): void {
        this.addClass('u-hidden', '.o-discovery-assistant-intro__videoEnded');
        this.removeClass('u-hidden', '.o-discovery-assistant-intro__container')
    }

    private setLocale(locale: string): void {
        if (this._sessionService.getLanguage() != locale) {
            this._sessionService.setLanguage(locale);
            window.location.reload();
        }
        else {
            this._buttonLocales.forEach((buttonLocale) => {
                buttonLocale.disabled = buttonLocale.dataset.locale == locale;
                if (buttonLocale.disabled) {
                    buttonLocale.classList.add('o-discovery-assistant-intro__locale--current');
                }
                else {
                    buttonLocale.classList.remove('o-discovery-assistant-intro__locale--current');
                }
            });
        }
    }

    private openIntroVideo(): void {
        const introEncoding: { id: number, secret: string} = this._assistant.introEncoding;
        this._mediaPlayerService.loadMedia(introEncoding?.id ? 'v2': 'brightcove', {
            type: 'video',
            video: {
                id: introEncoding?.id || this._assistant.introVideo,
                secret: introEncoding?.secret,
                title: USER_LOCALE.siteName
            },
            controls: {
                miniPlayer: 'disable',
                chromecast: false,
                skip: true,
                skipText: USER_LOCALE.goToQuestions
            }
        });
        setTimeout(() => {
            this.onCloseVideoEnded();
        }, 1000);      
    }   

    private showVideoEnded(): void {
        this.addClass('u-hidden', '.o-discovery-assistant-intro__container');
        this.removeClass('u-hidden', '.o-discovery-assistant-intro__videoEnded');
    }

    public dispose(): void {
        this._mediaPlayerService.off(this);
        super.dispose();
    }
}
